import { render, staticRenderFns } from "./MarketingReports.vue?vue&type=template&id=76934b83&"
import script from "./MarketingReports.vue?vue&type=script&lang=js&"
export * from "./MarketingReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports